import { Injectable, OnDestroy, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuCommand } from '../shared/models/menu-command';
import {
  routeLogoff,
  routeSearch,
  routeSettings,
  routeWebDoku,
  routeInfoChanged,
  routeInfoHistory,
  routeInfoWebDoku,
  routeDocumentNavigation,
  routeBasicNavigation,
  routeManual, routeCustomNavigation
} from '../livedokweb.routes';
import { AuthService } from '../route/auth/auth.service';
import { WebdokuService } from '../web-doku/webdoku.service';
import { RBCheck } from '@ldw/roesberg';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SettingsService } from '../shared/settings/settings.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService implements OnDestroy {
  protected translate = inject(TranslateService);
  protected authService = inject(AuthService);
  protected webDokuService = inject(WebdokuService);
  protected route = inject(ActivatedRoute);
  protected settingsService = inject(SettingsService);

  protected subscription: Subscription = new Subscription();

  public cmdWebDoku!: MenuCommand;
  public cmdDocuments!: MenuCommand;
  public cmdLoops!: MenuCommand;
  public cmdCustomNavigation!: MenuCommand;
  public cmdSearch!: MenuCommand;
  public cmdSettings!: MenuCommand;
  public cmdSignOff!: MenuCommand;
  public cmdUser!: MenuCommand;
  public cmdInfoChanged!: MenuCommand;
  public cmdInfoHistory!: MenuCommand;
  public cmdInfoWebDoku!: MenuCommand;
  public cmdDefaultHelp!: MenuCommand;
  public cmdCustomHelp!: MenuCommand;

  constructor() {
    const webDokuService = this.webDokuService;
    const settingsService = this.settingsService;

    this.buildCommands();
    this.subscription.add(
      webDokuService.webDokuChange.subscribe(() => {
        this.buildCommands();
      })
    );
    this.subscription.add(
      settingsService.settingsLoaded.subscribe(() => {
        this.buildCommands();
      })
    );
  }

  // wird nicht aufgerufen !
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public buildCommands(): void {
    const wd = this.webDokuService.currentWebDokuId;
    this.cmdWebDoku = this.newCommand('topic', routeWebDoku);
    this.cmdDocuments = this.newCommand('article', `${routeDocumentNavigation}/${wd}`, true);
    this.cmdLoops = this.newCommand('home', `${routeBasicNavigation}/${wd}`, true);
    this.cmdCustomNavigation = this.newCommand('format_align_justify', `${routeCustomNavigation}/${wd}`, true);
    this.cmdInfoChanged = this.newCommand('published_with_changes', `${routeInfoChanged}/${wd}`, true);
    this.cmdInfoHistory = this.newCommand('history_toggle_off', `${routeInfoHistory}/${wd}`, true);
    this.cmdInfoWebDoku = this.newCommand('analytics', `${routeInfoWebDoku}/${wd}`, true);
    this.cmdSearch = this.newCommand('search', `${routeSearch}/${wd}`, true);
    this.cmdSettings = this.newCommand('settings', routeSettings);
    this.cmdSignOff = this.newCommand('power_settings_new', routeLogoff);
    this.cmdUser = this.newCommand('person', 'user'); /* not a real route ! */

    const sett = this.settingsService.settings.helpSettings;
    if (sett.defaultHelpFileVisible) {
      this.cmdDefaultHelp = this.newCommand('help', routeManual);
    }
    if (sett.customHelpFileVisible()) {
      this.cmdCustomHelp = new MenuCommand(this.translate);
      this.cmdCustomHelp.icon = 'info';
      this.cmdCustomHelp.route = sett.customHelpFile;
      this.cmdCustomHelp.customText = sett.customHelpFileText;
      this.cmdCustomHelp.isExternalRoute = true;
    }
  }

  newCommand(icon: string, route: string, needWebDoku = false): MenuCommand {
    const cmd = new MenuCommand(this.translate);
    cmd.icon = icon;
    cmd.route = route;
    cmd.transId = this.splitString(route);
    cmd.needWebDoku = needWebDoku;
    return cmd;
  }

  splitString(text: string): string {
    if (RBCheck.isNullOrEmpty(text)) {
      return '';
    }
    const parts = text.split('/');
    if (parts.length <= 1) {
      return text;
    }
    return parts[0];
  }
}
